import moment from "moment";

function ConvertToReadableDateTime(d) {
  let date = new Date(d);
  return moment(date).format('MMMM Do, H:mm')
}

export default ConvertToReadableDateTime;